import React, { ChangeEvent, useEffect, useRef, useState } from "react";

interface IFormInputImageProps {
  label: string;
  id: string;
  value?: string | undefined;
  required?: boolean;
  placeholderImage: string;
  onChange: (
    id: string,
    value: string | undefined,
    files: FileList | null
  ) => void;
}

function FormInputImage({
  label,
  id,
  value,
  required,
  placeholderImage,
  onChange,
}: IFormInputImageProps) {
  const [image, setImage] = useState<string | undefined>(value);

  // Convert the placeholder image path to base64 and initialize the state
  useEffect(() => {
    if (!value) {
      fetch(placeholderImage)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            setImage(reader.result as string);
          };
          reader.readAsDataURL(blob);
        })
        .catch((error) =>
          console.error("Error loading placeholder image:", error)
        );
    }
  }, [value, placeholderImage]);

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = reader.result as string;
        setImage(base64String);
        onChange(id, base64String, event.target.files);
      };

      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setImage(placeholderImage);
    onChange(id, undefined, null);
  };

  return (
    <div className="form-input-image">
      <label htmlFor={`${id}-input`} className="form-label">
        {label}
        {required && <>*</>}
      </label>
      <div className="image-upload-container">
        <label
          htmlFor={`${id}-input`}
          className="image-preview block cursor-pointer"
          style={{
            border: "1px dashed #ccc",
            borderRadius: "8px",
            position: "relative",
          }}
        >
          <img
            src={image}
            alt=""
            className="preview-image"
            style={{
              width: "100%",
              minHeight: "300px",
              maxHeight: "300px",
              objectFit: "contain",
            }}
          />
          {!value && (
            <p
              className="upload-placeholder"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                color: "#888",
              }}
            >
              Click to upload
            </p>
          )}
        </label>
        <div
          className="image-controls"
          style={{
            display: "flex",
            justifyContent: "end",
            gap: "8px",
            marginTop: "8px",
          }}
        >
          <label
            htmlFor={`${id}-input`}
            className="button"
            style={{
              cursor: "pointer",
              padding: "8px 16px",
              backgroundColor: "#a6a6a6",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
            }}
          >
            Change
          </label>
          <button
            type="button"
            onClick={handleRemoveImage}
            className="button"
            style={{
              padding: "8px 16px",
              backgroundColor: "#a6a6a6",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
            }}
          >
            Remove
          </button>
        </div>
        <input
          type="file"
          id={`${id}-input`}
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleImageChange}
        />
      </div>
    </div>
  );
}

export default FormInputImage;
